'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const DetectionFrequencyChart = dynamic(
  () => import('./charts/DetectionFrequencyChart'),
  { ssr: false, loading: () => <div className="h-[200px] animate-pulse bg-muted rounded-xl" /> }
);

const SpectrogramBandChart = dynamic(
  () => import('./charts/SpectrogramBandChart'),
  { ssr: false, loading: () => <div className="h-[200px] animate-pulse bg-muted rounded-xl" /> }
);

const DOACoverageChart = dynamic(
  () => import('./charts/DOACoverageChart'),
  { ssr: false, loading: () => <div className="h-[200px] animate-pulse bg-muted rounded-xl" /> }
);

export default function MissionChartsRow() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-5 mt-5">
      <div className="bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <p className="text-sm font-semibold text-foreground">Detection Frequency</p>
          <p className="text-xs text-muted-foreground">Events per 15-min window — last 6h</p>
        </div>
        <DetectionFrequencyChart />
      </div>
      <div className="bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <p className="text-sm font-semibold text-foreground">Spectrogram Band Energy</p>
          <p className="text-xs text-muted-foreground">Current frame — dB by frequency band</p>
        </div>
        <SpectrogramBandChart />
      </div>
      <div className="bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <p className="text-sm font-semibold text-foreground">Beamformer DOA Activity</p>
          <p className="text-xs text-muted-foreground">Detection density by azimuth sector</p>
        </div>
        <DOACoverageChart />
      </div>
    </div>
  );
}